import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppNotice } from '../../context/AppNoticeContext';
import { CloseIcon } from '../hand/icons';
import { withReturnTo, currentPath } from '../../utils/returnTo';

/**
 * The quiet version of the resume prompt. After three dismissals the sheet stops
 * interrupting and this strip takes over — same ask, no modal.
 * docs/plans/2026-08-handoff-layout/09-app-notices.md
 */
export default function ResumeInlineBanner() {
  const navigate = useNavigate();
  const location = useLocation();
  const { inlineResume, hideBanner, openBanner } = useAppNotice();
  if (!inlineResume) return null;

  const open = () => navigate(withReturnTo(openBanner(), currentPath(location)));

  return (
    <div className="border-b-2 border-black" style={{ background: '#FFCCE6' }}>
      <div className="mx-auto flex max-w-content flex-wrap items-center gap-3 px-4 py-2.5 sm:px-8">
        <span className="font-mono text-[11px] font-bold uppercase tracking-[0.14em] text-black">
          {inlineResume.eyebrow}
        </span>
        <span className="min-w-0 flex-1 truncate text-[13px] text-black">
          {inlineResume.headline}
        </span>
        <button
          type="button"
          onClick={open}
          className="flex-shrink-0 border-2 border-black bg-black px-3 py-1.5 font-mono text-[11px] font-bold uppercase tracking-[0.12em] text-white transition-colors hover:bg-white hover:text-black"
        >
          Finish it
        </button>
        <button
          type="button"
          onClick={hideBanner}
          aria-label="Hide for today"
          className="flex h-7 w-7 flex-shrink-0 items-center justify-center border-2 border-black text-black transition-colors hover:bg-black hover:text-white"
        >
          <CloseIcon size={12} />
        </button>
      </div>
    </div>
  );
}
